






















import Vue from 'vue'
import Component from 'vue-class-component'
import ScrollView from '@/components/ScrollView.vue'
import { VPopover } from 'v-tooltip'
import { CommentUserOptions } from '@/interfaces'

@Component({
  components: {
    ScrollView,
    VPopover
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    searchSymbol: {
      type: String,
      default: '@'
    },
    input: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: []
    }
  }
})
export default class Mentions extends Vue {
  isOpened: boolean = false
  lastWord: string = ''
  cursorPosition: number = 0
  selectedIndex: number = 0
  cursorElement: any = null

  get filteredItems () {
    if (!this.$props.items || !this.$props.items.length) {
      return []
    }
    if (!this.lastWord || !this.isOpened) {
      return this.$props.items
    }

    const searchBy = this.lastWord.replace(this.$props.searchSymbol, '').toLowerCase()
    return this.$props.items.filter((item: any) =>
        item.label.toLowerCase().includes(searchBy) || item.value.toLowerCase().includes(searchBy)
    )
  }

  binded () {
    return {
      submitMessage: this.submitMessage,
      inputSymbol: this.inputSymbol,
      selectSelectedIndexItem: this.selectSelectedIndexItem,
      changeSelectedIndex: this.changeSelectedIndex
    }
  }

  selectSelectedIndexItem (event: any) {
    if (this.isOpened) {
      if (event.which === 13) {
        const scrollbar: any = this.$refs.scrollbar
        setTimeout(() => {
          scrollbar.$el.querySelector(`.mentionResult-${this.selectedIndex}`).click()
        }, 100)
      }
      if ([38, 40, 13].includes(event.which)) {
        event.preventDefault()
        event.stopPropagation()
        return false
      }
    }
  }

  checkInput () {
    const input = this.$props.input
    return !input
  }

  changeSelectedIndex (direction: string | null, index: number | null = null) {
    if (index && !direction) {
      this.selectedIndex = index
      return
    }

    if (direction) {
      const alignScroll = () => {
        const scrollbar: any = this.$refs.scrollbar
        const rect = scrollbar.$el.getBoundingClientRect()
        const listPaddings = 16
        const itemHeight = 24.17
        const height = rect.height - listPaddings
        const currentPositionTop = this.selectedIndex * itemHeight
        if (currentPositionTop - scrollbar.$el.scrollTop > height - itemHeight && direction === 'down') {
          scrollbar.$el.scrollTop = currentPositionTop - height + itemHeight
        } else if (currentPositionTop < scrollbar.$el.scrollTop && direction === 'up') {
          scrollbar.$el.scrollTop = currentPositionTop - itemHeight
        }
      }
      if (direction === 'up' && this.selectedIndex > 0) {
        this.selectedIndex--
        alignScroll()
      } else if (this.selectedIndex < this.$props.items.length - 1) {
        this.selectedIndex++
        alignScroll()
      }
      return
    }
    if (index) {
      this.selectedIndex = index
    }
  }

  inputSymbol (event: any) {
    if (this.$props.type === 'text') {
      this.cursorPosition = event.target.selectionStart
    } else {
      const selection = document.getSelection()
      if (selection) {
        this.cursorPosition = selection.anchorOffset
        this.cursorElement = selection.anchorNode
      }
    }
    this.lastWord = (this.$props.type === 'text' ? event.target.value : this.cursorElement.textContent).slice(0, this.cursorPosition).split(' ').pop()
    this.isOpened = this.lastWord[0] === this.$props.searchSymbol
  }

  select (item: any) {
    let newValue = ''
    if (this.$props.type === 'text') {
      let start = this.$props.input.slice(0, this.cursorPosition)
      const end = this.$props.input.slice(this.cursorPosition)
      if (this.$props.input[this.cursorPosition - 1] === ' ' || this.$props.input[this.cursorPosition - 1] === ' ') {
        newValue = `${start}${this.$props.searchSymbol}${item.value}${end}`
      } else {
        const split = start.split(' ')
        split.pop()
        newValue = `${split.join(' ')} ${this.$props.searchSymbol}${item.value} ${end}`
      }
      this.$emit('inputUpdate', newValue)
    } else {
      let start = this.cursorElement.textContent.slice(0, this.cursorPosition)
      const end = this.cursorElement.textContent.slice(this.cursorPosition)
      if (this.cursorElement.textContent[this.cursorPosition - 1] === ' ' || this.cursorElement.textContent[this.cursorPosition - 1] === ' ') {
        newValue = `${start}<span>&nbsp;</span><span class="mention-tag">${this.$props.searchSymbol}${item.value}</span><span>&nbsp;</span><span autofocus></span>${end}`
      } else {
        const split = start.split(' ')
        split.pop()
        newValue = `${split.join(' ')}<span>&nbsp;</span><span class="mention-tag">${this.$props.searchSymbol}${item.value}</span><span>&nbsp;</span><span autofocus></span>${end}`
      }
      const span = document.createElement('span')
      span.innerHTML = newValue
      this.cursorElement.replaceWith(span)
      setTimeout(() => {
        let p = span.querySelector('span[autofocus]')
        let s = window.getSelection()
        let r = document.createRange()
        if (p && s) {
          r.setStart(p, 0)
          r.setEnd(p, 0)
          s.removeAllRanges()
          s.addRange(r)
        }
      }, 0)
      this.$emit('updateMessage')
    }

    this.isOpened = false
  }

  submitMessage () {
    if (this.isOpened) {
      return
    }
    let value = this.$props.input

    // Sort items by value length (DESC) to ensure longer mentions are replaced first, avoiding substring issues.
    // Example: If "@Test" and "@Tester" exist, replace "@Tester" correctly without leaving "er" (e.g., "@Tester" -> "{{4123}}").
    const userOptions = this.$props.items as CommentUserOptions[]
    userOptions.sort((a, b) => b.value.length > a.value.length ? 1 : -1)

    userOptions.forEach((item: any) => {
      value = value.replace(`${this.$props.searchSymbol}${item.value}`, `{{${item.replaceValue}}}`)
    })
    console.log('value', value)
    this.$emit('submit', value)
  }
}
